import { useState, useEffect } from "react";
import axios from "axios";
import TPC_URL from "../../../utils/TPC_URL";

export const useEngineStatus = (group_code, project_code, isScheduling) => {
  const [engineStatus, setEngineStatus] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchEngineStatus = async () => {
    try {
      const res = await axios.get(
        `${TPC_URL}/api/tpc/engineStatus?group_code=${group_code}&project_code=${project_code}`
      );
      setEngineStatus(res.data.is_running || 0);
      setLoading(false);
    } catch (error) {
      console.error("[ERROR] fetchEngineStatus:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    // 페이지 진입 시 한 번 조회
    fetchEngineStatus();
  }, [group_code, project_code]);

  useEffect(() => {
    // 스케줄링 시작 시 한 번 더 조회
    if (isScheduling) {
      fetchEngineStatus();
    }
  }, [isScheduling]);
  useEffect(() => {
    const pollInterval = setInterval(() => {
      fetchEngineStatus();
    }, 5000); // 5초마다 폴링

    return () => clearInterval(pollInterval);
  }, [group_code, project_code]);

  return { engineStatus, loading, refetchEngineStatus: fetchEngineStatus };
};
